/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rte_Upload_FailedInputs */



/**
* | output |
* | --- |
* | "Upload failed" |
*
* @param {Rte_Upload_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const rte_upload_failed = /** @type {((inputs?: Rte_Upload_FailedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rte_Upload_FailedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Uploaden mislukt")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de l'envoi")
	return /** @type {LocalizedString} */ ("Upload failed")
});